// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.tep-koef-group[data-v-5b20a25d] {\r\n    display: flex;\r\n    align-items: center;\n}\n.tep-koef-group[data-v-5b20a25d] .dx-field {\r\n    padding: 0;\n}\n.btn-wrap[data-v-5b20a25d] {\r\n    margin-left: 10px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
